import { RemoteDeleteInternshipLocationImage } from 'data/usecases';
import { makeApiUrlInternshipLocationImage } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeleteInternshipLocationImage =
  (): RemoteDeleteInternshipLocationImage => {
    return new RemoteDeleteInternshipLocationImage(
      makeApiUrlInternshipLocationImage(),
      makeAxiosHttpClient(),
    );
  };
